// extracted by mini-css-extract-plugin
module.exports = {"container":"LoadingSpinnerButton_container__1la34","loader":"LoadingSpinnerButton_loader__z8fvm","rotation":"LoadingSpinnerButton_rotation__2j8Eb"};